import React, { useState } from "react";
import axios from "axios";
import courses from "../data/courseurl.json";

export const SearchProduct = () => {
    const [email, setEmail] = useState("");
    const [result, setResult] = useState([]);
    const [note, setNote] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const handlechange = (e) => {
        setEmail(e.target.value);
    }

    const sendNotification = (e) => {
        axios.post(`https://ecwid-paylog-backend.vercel.app/api/sendnotification`, {
            email: email,
            course: e.target.textContent,
        }).then(console.log("Message Sent"))
            .catch(error => console.log(error));
    }

    const handleSubmit = () => {
        let emailValid = true;

        if (!email || !email.trim()) {
            emailValid = false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            emailValid = (emailRegex.test(email));
        }
        setIsValid(emailValid);
        if (!emailValid) {
            console.log("Invalid email");
            return;
        }

        setIsLoading(true);


        axios.get(`https://app.ecwid.com/api/v3/9005044/orders?email=${email}`, {
            headers: {
                'Authorization': 'Bearer secret_vtLcku8UptgSBVTJSXHhahbRrsHG4YJV',
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            setIsLoading(false);
            const resultData = response.data;
            console.log(response.data)
            if (resultData.count === 0) {
                return setNote(<div>Email not found in our accounts. Please re-enter</div>);
            } else {
                const rows = resultData.items.map((item) => {
                    const { createDate, items } = item;

                    const utcDateTime = new Date(createDate);

                    const localDateTime = new Date(utcDateTime.getTime() + utcDateTime.getTimezoneOffset() * 60 * 1000);

                    const year = localDateTime.getFullYear();
                    const month = String(localDateTime.getMonth() + 1).padStart(2, '0');
                    const day = String(localDateTime.getDate()).padStart(2, '0');

                    const normalTime = `${year}-${month}-${day} `;

                    const tableRows = items.map((detail, index) => {
                        const { name } = detail;
                        const courseURL = courses.filter((course) => {
                            return course.course_name === name;
                        }).map((item, key) => {
                            return item.course_link;
                        });

                        return (
                            <tr key={index}>
                                <td>{normalTime}</td>
                                <td>
                                    {courseURL[0] === "discontinued" || courseURL[0] === "service"
                                        ?
                                        <>
                                            <a href="#" onClick={sendNotification}>{name}</a>
                                            <div className="error-tag">⚠ This item was a service that can only be used once.</div>
                                        </>
                                        :
                                        <a href={courseURL} onClick={sendNotification}>{name}</a>
                                    }
                                </td>
                            </tr>
                        )
                    })

                    return tableRows;
                })
                // setNote(<div>To locate your course, I need the email you used for Delivery (not the one for PayPal).
                //     You will see your previous purchases. Click on the Course Name to open your course.
                //     When you get there, be sure to BOOKMARK the course address (URL) for future reference.<br><br>
                //     <strong>NOTE:</strong> <span style={{ fontSize: "15px" }}>Sometimes there is a slight delay at PayPal. 
                //     If you just placed your order and it’s not found, wait 10-15 minutes, and try again.</span></div>)
                setResult(rows);
            }
        })
            .catch(function (error) {
                setIsLoading(false);
                console.log(error);
            })
    }

    return (
        <>
            <h2 className="title">Product Lookup Instructions</h2>
            <div style={{lineHeight: "1.1", textAlign: "center"}}>
                To locate your course, I need the email you used for Delivery (not the one for PayPal).
                You will see your previous purchases. Click on the Course Name to open your course.
                When you get there, be sure to BOOKMARK the course address (URL) for future reference.<br/>
                <strong>NOTE:</strong> <span style={{ fontSize: "15px", lineHeight: "1" }}>Sometimes there is a slight delay at PayPal. If you just placed your order and it's not found, wait 10-15 minutes, and try again.</span>
            </div>
            <p className="mt-5">Email *</p>
            <div className="flex flex-col items-start md:flex-row md:items-center">
                <div className="relative me-2">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 16">
                            <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
                            <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
                        </svg>
                    </div>
                    <input type="text" id="input-group-1" className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block  ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        onChange={handlechange}
                    />
                </div>
                <button type="button" className="mt-5 focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900 md:mt-2" onClick={handleSubmit}>Submit</button>
            </div>
            <div>
                {isLoading ? <div className="loadingPopup">Loading...</div> :
                    <>
                        {isValid
                            ?
                            <>
                                {note}
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Order Date</th>
                                            <th>Product Link</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {result}
                                    </tbody>
                                </table>
                            </>
                            :
                            <div>Please enter a valid email address.</div>
                        }
                    </>
                }
            </div>
        </>
    )
}
